import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { UploadCloud, IconX, OnUploladDragCursor } from "../IconButtons/SubMenuIcons";

export default function DialogM(props) {
  const [file, setFile] = React.useState(null);
  const [dragged, setDragged] = React.useState(false);
  const [hover, setHover] = React.useState(false);
  const [src, setSrc] = React.useState(null);
  const [error, setError] = React.useState(null);

  const ImageOnChange = (e) => {
    let file = e.target.files[0];

    if (file.size <= 10485760) {
      setError(null);
      setFile(e.target.files[0]);
      let reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onloadend = () => {
        setSrc(reader.result);
      };
    } else {
      setSrc(null);
      setFile(null);
      setError("Maximum file size exceeded");
    }
  };
  const cursorClipboard = `url("data:image/svg+xml;base64,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") 16 16, pointer`;

  const handleUpload = () => {
    props.handleUpload(file, imageEl.current.naturalHeight);
    setFile(null);
  };
  const StartDrag = (e) => {
    e.preventDefault();
    let img = new Image();
    img.src = "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg";
    e.dataTransfer.setDragImage(img, 10, 10);
    if (!dragged) {
      setDragged(true);
    }
  };

  const changeImgSize = () => {
    imageEl.current.style.height = "100%";
  };

  const LeaveDrag = (e) => {
    e.preventDefault();

    if (dragged) {
      setDragged(false);
    }
  };

  const StartHover = () => {
    if (!hover) {
      setHover(true);
    }
  };

  const StopHover = () => {
    if (hover) {
      setHover(false);
    }
  };

  const handleDrop = (event) => {
    event.stopPropagation();
    event.preventDefault();
    let file = event.dataTransfer.files[0];
    if (file.size <= 10485760) {
      setError(null);
      setFile(event.dataTransfer.files[0]);
      let reader = new FileReader();
      reader.readAsDataURL(event.dataTransfer.files[0]);
      reader.onloadend = () => {
        setSrc(reader.result);
      };
    } else {
      setSrc(null);
      setFile(null);
      setError("Maximum file size exceeded");
    }
  };
  const imageEl = React.useRef();
  return (
    <div>
      <Dialog
        style={{ width: "100%" }}
        open={props.open}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          style: {
            boxShadow: "none",
            width: "960px",
            height: "627px",
          },
        }}
        onClose={props.onClose}
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "end",
            margin: 0,
            padding: 0,
            marginTop: "21px",
            marginRight: "23px",
          }}
        >
          <IconX
            onClick={() => {
              props.onClose();
              setSrc(null);
              setFile(null);
            }}
          />
        </DialogTitle>
        <DialogContent
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "7px",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <div
            onMouseEnter={StartHover}
            onMouseLeave={StopHover}
            onDrop={handleDrop}
            onDragOver={StartDrag}
            onDragLeave={LeaveDrag}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignItems: "center",
              border: !error ? "1px dashed #D4D5DE" : "1px dashed red",
              width: "531px",
              height: "293px",
              // cursor: cursorClipboard,
              background: hover && "#F0F1F7",
              borderRadius: "10px",
              boxSizing: "border-box",
            }}
          >
            <div style={{ paddingTop: "60px", boxSizing: "border-box", height: "150px" }}>
              {file && <img ref={imageEl} onLoad={changeImgSize} src={src} />}
              {!file && <UploadCloud />}
            </div>
            <div style={{ marginTop: "24px", display: "flex", flexDirection: "column" }}>
              <p
                style={{
                  color: "#585858",
                  fontFamily: "arial",
                  fontStyle: "normal",
                  fontWeight: "800",
                  fontSize: "14px",
                  lineHeight: "160%",
                }}
              >
                Select a file or drag and drop here
              </p>
              <p
                style={{
                  marginTop: "-12px",
                  marginBototm: "24px",
                  color: "#D4D5DE",
                  fontFamily: "arial",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "12px",
                  lineHeight: "160%",
                }}
              >
                JPG, PNG, file size no more than 10MB
              </p>
            </div>

            <input
              type="file"
              id="file"
              style={{
                height: "100%",
                width: "100%",
                top: "0",
                left: "0",
                transparency: "100%",
                display: "none",
              }}
              onChange={(e) => ImageOnChange(e)}
            />
            <label
              htmlFor="file"
              style={{
                width: "136px",
                height: "32px",
                color: "#01AFFD",
                boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.06)",
                // textAlign: 'center',
                backgroundColor: `${hover ? "#F0F1F7" : "#FFFFFF"}`,
                borderRadius: "20px",
                border: "1px solid #01AFFD",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxSizing: "border-box",
                paddingBottom: "4px",
              }}
            >
              Select File
            </label>
          </div>

          <div style={{ color: "red", fontFamily: "Inter", fontWeight: "bold" }}>
            {error && <div>{error}</div>}
          </div>
        </DialogContent>
        <DialogActions
          style={{
            paddingBottom: 0,
            marginBottom: "24px",
            display: "flex",
            justifyContent: "center",
            rowGap: "17px",
          }}
        >
          <button
            style={{
              borderRadius: "20px",
              width: "136px",
              height: "32px",
              color: "#000000",
              background: "none",
              border: "none",
              fontFamily: "Inter",
              fontSize: "12px",
              lineHeight: "100%",
              fontWeight: "600",
            }}
            onClick={() => {
              props.onClose();
              setSrc(null);
              setFile(null);
              setError(null);
            }}
          >
            Cancel
          </button>
          <button
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "100%",
              fontWeight: "600",
              color: "#FFFFFF",
              alignItems: "center",
              width: "136px",
              height: "32px",
              borderRadius: "20px",
              background: file ? "#01AFFD" : "#E1F2F6",
              border: "none",
            }}
            onClick={handleUpload}
            autoFocus
          >
            Place Photo
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
